import httpClient from '../../api/httpClient'
import { fold, Maybe, Union } from '../../lib'
import { Paginate } from '../../lib/types/Paginate'
import { update } from '../../lib/vuex'
import router from '../../router'

const Status = Union('Status2', {
  Idle: [],
  Processing: [],
  Done: [],
  Failed: [],
})

export default {
  state: {
    ui: {
      offers: {},
      offersStatus: Status.Idle(),
      search: { term: '', group: Maybe.None() },
      pagination: Paginate.defaultState,
    },
  },

  mutations: {
    update(state, { path, value }) {
      state.ui = update(state.ui, path, value)
    },
  },

  getters: {
    offersPerPage: ({
      ui: {
        offers,
        pagination: { current },
      },
    }) => offers[current] || [],

    filters: ({
      ui: {
        search: { term, group },
      },
    }) => ({
      term,
      group: fold(
        group,
        (id) => id,
        () => '',
      ),
    }),

    offersStatus: ({ ui: { offersStatus } }) => offersStatus,

    pagination: ({ ui: { pagination } }) => pagination,
  },

  actions: {
    fetchOffers({ commit, getters, state }, page = 1) {
      commit('update', { path: 'offersStatus', value: Status.Processing() })
      const { term, group } = getters.filters
      const params = { query: term, group, page }
      const { pagination } = state.ui
      const url = '/offers'
      Paginate.setCurrentPage({ pagination, page, commit, url, params })
        .then((response) => {
          if (response) {
            const { current_page, data } = response.data
            let value = { [current_page]: data }
            if (current_page !== 1) {
              value = { ...state.ui.offers, ...value }
            }
            commit('update', { path: 'offers', value })
          }
          commit('update', { path: 'offersStatus', value: Status.Done() })
        })
        .catch((err) => {
          console.error("Couldn't fetch offers, ", err)
          commit('update', { path: 'offersStatus', value: Status.Failed() })
        })
    },

    duplicateOffer(_, offerId) {
      httpClient
        .post(
          `/admin/offers/${offerId}/duplicate`,
          {},
        )
        .then((response) => {
          router.push({ name: 'Edit Offer', params: { id: response.data.id } })
        })
        .catch((err) => {
          console.error(`Couldn't duplicate offer id=${offerId}, `, err)
        })
    },

    destroy({ commit, state }, id) {
      httpClient
        .delete(`/v2/offers/${id}`)
        .then(() => {
          const {
            offers,
            pagination: { current },
          } = state.ui
          const currentList = { [current]: offers[current].filter((i) => i.id !== id) }
          const value = { ...offers, ...currentList }
          commit('update', { path: 'offers', value })
        })
        .catch((err) => {
          console.error(`Couldn't delete offer id=${id}, `, err)
        })
    },
  },
}
